// ActivityCard.tsx
import { Typography } from 'antd';
import { ActivityData } from './dashboardConfig';

const { Text } = Typography;

interface ActivityCardProps {
  data: ActivityData;
}

export const ActivityCard: React.FC<ActivityCardProps> = ({ data }) => {
  const { title, count, total, icon, iconBg, iconColor, countColor } = data;

  return (
    // ADDED border-none and border-0 here
    <div className="flex-1 min-w-[200px] p-4 bg-white rounded-xl shadow-sm border-none border-0">
      <div className="flex items-center space-x-3">
        {/* Icon Container */}
        <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${iconBg} ${iconColor} text-xl`}>
          {icon}
        </div>

        {/* Text Content */}
        <div>
          <Text className="block text-sm text-gray-500 font-medium">{title}</Text>
          <div className="flex items-baseline">
            <Text className={`text-2xl font-bold ${countColor} mr-1`}>
              {count}
            </Text>
            <Text className="text-xs text-gray-400">
              Total: {total}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};